// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.m-about {
  padding: 0px;
}
@media screen and (max-width: 1200px) {
  .m-about {
    margin-top: 20px;
  }
}
@media screen and (max-width: 1000px) {
  .m-about {
    width: 100%;
  }
}
.m-about.m-image-block {
  padding-left: 15px;
  padding-right: 15px;
}
@media screen and (max-width: 1200px) {
  .m-about.m-image-block {
    margin-top: 0px;
  }
}
@media screen and (max-width: 850px) {
  .m-about.m-image-block {
    margin-top: 20px;
  }
}
@media screen and (max-width: 767px) {
  .m-about.m-image-block {
    margin-top: 20px;
  }
}
.m-about .about-condition {
  width: 100%;
}
.m-about .no-pad-right {
  padding-right: 0px;
}
.m-about h2 {
  font-weight: bold;
  margin: 20px 0 5px 0;
}
.m-about .field_label,
.m-about .field_detail {
  display: table-cell;
  word-wrap: break-word;
  -webkit-table-layout: fixed;
  -moz-table-layout: fixed;
  -ms-table-layout: fixed;
  -o-table-layout: fixed;
  table-layout: fixed;
  font-size: 16px;
  line-height: 23px;
}
@media screen and (min-width: 769px) and (max-width: 1199px) {
  .m-about .field_label,
  .m-about .field_detail {
    display: block !important;
  }
}
@media screen and (max-width: 599px) {
  .m-about .field_label,
  .m-about .field_detail {
    width: 100% !important;
    display: block !important;
    padding: 0px !important;
  }
}
.m-about .field_label {
  width: 85px;
}
.m-about .field_detail {
  padding-left: 2px;
}
.m-about .list-group .list-group-item {
  display: table;
  width: 50%;
  border: none;
  padding: 3px 0px;
  font-size: 16px;
}
@media only screen and (max-width: 767px) {
  .m-about .list-group .list-group-item {
    width: 100%;
  }
}
@media screen and (max-width: 599px) {
  .m-about .list-group .list-group-item {
    display: block;
  }
}
.m-about .list-group .list-group-item.col-sm-6 {
  display: block;
}
@media (min-width: 768px) {
  .m-about .list-group .list-group-item.col-sm-6 {
    width: 50%;
  }
}

@media screen and (max-width: 991px) {
  .m-about .no-pad-left {
    padding-right: 0;
  }
}
.edit-image-wrapper {
  position: relative;
}

.person-title {
  max-width: 300px;
  width: 100%;
  margin-right: 15px;
  margin-bottom: 15px;
}
@media screen and (max-width: 1200px) {
  .person-title {
    max-width: 240px;
  }
}
.person-title .img-responsive {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  background: #f2f2f2;
}
.person-title .m-b-sm {
  padding: 5px;
}

.upload_button_holder {
  position: absolute;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  margin-top: -33px;
}
.upload_button_holder .upload_button {
  position: relative;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 5px 0;
  border-radius: 0;
  width: 100%;
  height: 32px;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
  display: block;
}
.upload_button_holder .cloudinary_fileupload {
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
}

.titlename.no-mg-top {
  margin-top: 2px !important;
}

.right-buttons {
  position: absolute;
  right: 10px;
  z-index: 9999;
}

.no-margin {
  margin: 0;
}

.m-about p {
  font-size: 14px;
  line-height: 23px;
}

.profile-heading {
  margin-left: -20px;
  width: 105%;
}

.client-detail {
  position: relative;
  height: auto;
}
.client-detail .profile-headers {
  clear: both;
  float: left;
  width: 100%;
  margin: 30px 0;
  font-size: 18px;
  font-family: "Conv_museo-500-webfont";
}
.client-detail .profile-headers .profile-equation-wrapper {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-wrapper span {
  color: #fff;
  padding: 7px;
}
.client-detail .profile-headers .profile-equation-wrapper .eq-plus {
  color: #6d6e71;
}
.client-detail .profile-headers .profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-result a {
  color: #fff;
  text-decoration: none;
}
.client-detail .client_description {
  clear: both;
  text-align: justify;
  font-size: 16px;
  margin-bottom: 30px;
  -ms-column-count: 2;
  column-count: 2;
  -ms-column-gap: 20;
  column-gap: 20;
}
.client-detail .client_description span.profile-desc {
  font-weight: 700;
}

.right-label-text .eq-implementer {
  background-color: rgb(245, 67, 89) !important;
}
.right-label-text .eq-clarifier {
  background-color: rgb(0, 173, 208) !important;
}
.right-label-text .eq-ideator {
  background-color: rgb(255, 121, 0) !important;
}

::ng-deep .user-profile-icon-wrapper {
  margin-top: -12px;
  margin-left: 19px;
}
::ng-deep .user-profile-icon-wrapper .unliked-profile {
  display: inline-block;
  margin-top: 20px;
}

.profile-btn-wrapper {
  display: inline-block;
  margin-top: 5px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.profile-btn-wrapper a {
  font-size: 12px;
}

.collaborate-profile {
  margin: 10px 0 15px 0;
  float: left;
  width: 100%;
}
.collaborate-profile span.left-label.profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 17px;
  color: #fff;
}
.collaborate-profile span.left-label.profile-equation-result a {
  color: #fff !important;
  text-decoration: none;
}
.collaborate-profile ::ng-deep .profile-equation-wrapper span {
  padding: 7px;
  color: #fff;
  font-size: 18px;
  font-weight: normal;
  display: inline-block;
}

.profile-headers h2 {
  display: inline-block;
}

.right-buttons.collaboration-profile a {
  padding: 4px 15px !important;
  font-size: 13px;
  margin: 0 !important;
  height: 26px !important;
  display: inline-block;
  vertical-align: top;
  line-height: 18px;
}
.right-buttons.collaboration-profile a.btn {
  text-decoration: none !important;
}

.client-detail #cbpf6 {
  margin-top: 10px;
}

.m-about .field_label,
.m-about .m-image-block,
.m-about .titlename span,
.list-unstyled .not-strong {
  font-family: "Open Sans";
}

.th-pf-links {
  margin-top: 6px;
  margin-left: 10px;
  display: inline-block;
}

.m-about .field_label.more-label {
  width: 125px;
}

::ng-deep .inline-profile {
  display: inline-block;
}

@media only screen and (max-width: 991px) {
  .member-orgs__tbl-wrp {
    overflow-x: scroll;
  }
}
.member-orgs__tbl-wrp thead th {
  min-width: 135px;
}

table.user-profile tr:nth-child(even):hover {
  background-color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/user-profile/user-profile.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,YAAA;AAgZF;AA9YE;EAHF;IAII,gBAAA;EAiZF;AACF;AA/YE;EAPF;IAQI,WAAA;EAkZF;AACF;AAhZE;EACE,kBAAA;EACA,mBAAA;AAkZJ;AAhZI;EAJF;IAKI,eAAA;EAmZJ;AACF;AAjZI;EARF;IASI,gBAAA;EAoZJ;AACF;AAlZI;EAZF;IAaI,gBAAA;EAqZJ;AACF;AAlZE;EACE,WAAA;AAoZJ;AAjZE;EACE,kBAAA;AAmZJ;AAhZE;EACE,iBAAA;EACA,oBAAA;AAkZJ;AA/YE;;EAEE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAiZJ;AA/YI;EAZF;;IAaI,yBAAA;EAmZJ;AACF;AAjZI;EAhBF;;IAiBI,sBAAA;IACA,yBAAA;IACA,uBAAA;EAqZJ;AACF;AAlZE;EACE,WAAA;AAoZJ;AAjZE;EACE,iBAAA;AAmZJ;AA/YI;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAiZN;AA/YM;EAPF;IAQI,WAAA;EAkZN;AACF;AAhZM;EAXF;IAYI,cAAA;EAmZN;AACF;AAhZI;EACE,cAAA;AAkZN;AAhZM;EAHF;IAII,UAAA;EAmZN;AACF;;AA9YA;EAEI;IACE,gBAAA;EAgZJ;AACF;AA1YA;EACE,kBAAA;AA4YF;;AAzYA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA4YF;AA1YE;EANF;IAOI,gBAAA;EA6YF;AACF;AA3YE;EACE,eAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AA6YJ;AA1YE;EACE,YAAA;AA4YJ;;AAxYA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AA2YF;AAzYE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,WD9Ee;EC+Ef,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA2YJ;AAxYE;EACE,UAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA0YJ;;AApYA;EACE,0BAAA;AAuYF;;AApYA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AAuYF;;AApYA;EACE,SAAA;AAuYF;;AApYA;EACE,eAAA;EACA,iBAAA;AAuYF;;AApYA;EACE,kBAAA;EACA,WAAA;AAuYF;;AApYA;EACE,kBAAA;EAEA,YAAA;AAsYF;AApYE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,qCAAA;AAsYJ;AApYI;EACE,wEAAA;AAsYN;AApYM;EACE,WDnJW;ECoJX,YAAA;AAsYR;AAnYM;EACE,cDvLa;AC4jBrB;AAjYI;EACE,mBD5Le;EC6Lf,YAAA;EACA,wEAAA;AAmYN;AAjYM;EACE,WDlKW;ECmKX,qBAAA;AAmYR;AA9XE;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,cAAA;AAgYJ;AA9XI;EACE,gBAAA;AAgYN;;AAzXE;EACE,6CAAA;AA4XJ;AAzXE;EACE,6CAAA;AA2XJ;AAxXE;EACE,6CAAA;AA0XJ;;AArXA;EACE,iBAAA;EACA,iBAAA;AAwXF;AAtXE;EACE,qBAAA;EACA,gBAAA;AAwXJ;;AApXA;EACE,qBAAA;EACA,eAAA;EACA,wEAAA;AAuXF;AArXE;EACE,eAAA;AAuXJ;;AAnXA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;AAsXF;AApXE;EACE,mBDrQiB;ECsQjB,YAAA;EACA,wEAAA;EACA,eAAA;EACA,WD1Oe;ACgmBnB;AApXI;EACE,sBAAA;EACA,qBAAA;AAsXN;AAjXI;EACE,YAAA;EACA,WDrPa;ECsPb,eAAA;EACA,mBAAA;EACA,qBAAA;AAmXN;;AA9WA;EACE,qBAAA;AAiXF;;AA7WE;EACE,4BAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAgXJ;AA9WI;EACE,gCAAA;AAgXN;;AA1WA;EACE,gBAAA;AA6WF;;AA1WA;;;;EAIE,wBAAA;AA6WF;;AA1WA;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;AA6WF;;AA1WA;EACE,YAAA;AA6WF;;AA1WA;EACE,qBAAA;AA6WF;;AAtWI;EAFF;IAGI,kBAAA;EA0WJ;AACF;AAtWO;EACC,gBAAA;AAwWR;;AA9VQ;EACE,yBAAA;AAiWV","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n.m-about {\n  padding: 0px;\n\n  @media screen and (max-width: 1200px) {\n    margin-top: 20px;\n  }\n\n  @media screen and (max-width:1000px) {\n    width: 100%;\n  }\n\n  &.m-image-block {\n    padding-left: 15px;\n    padding-right: 15px;\n\n    @media screen and (max-width: 1200px) {\n      margin-top: 0px;\n    }\n\n    @media screen and (max-width: 850px) {\n      margin-top: 20px;\n    }\n\n    @media screen and (max-width: 767px) {\n      margin-top: 20px;\n    }\n  }\n\n  .about-condition {\n    width: 100%;\n  }\n\n  .no-pad-right {\n    padding-right: 0px;\n  }\n\n  h2 {\n    font-weight: bold;\n    margin: 20px 0 5px 0;\n  }\n\n  .field_label,\n  .field_detail {\n    display: table-cell;\n    word-wrap: break-word;\n    -webkit-table-layout: fixed;\n    -moz-table-layout: fixed;\n    -ms-table-layout: fixed;\n    -o-table-layout: fixed;\n    table-layout: fixed;\n    font-size: 16px;\n    line-height: 23px;\n\n    @media screen and (min-width:769px) and (max-width:1199px) {\n      display: block !important;\n    }\n\n    @media screen and (max-width: 599px) {\n      width: 100% !important;\n      display: block !important;\n      padding: 0px !important;\n    }\n  }\n\n  .field_label {\n    width: 85px;\n  }\n\n  .field_detail {\n    padding-left: 2px;\n  }\n\n  .list-group {\n    .list-group-item {\n      display: table;\n      width: 50%;\n      border: none;\n      padding: 3px 0px;\n      font-size: 16px;\n\n      @media #{$mobile} {\n        width: 100%;\n      }\n\n      @media screen and (max-width: 599px) {\n        display: block;\n      }\n    }\n\n    .list-group-item.col-sm-6 {\n      display: block;\n\n      @media(min-width:768px) {\n        width: 50%;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .m-about {\n    .no-pad-left {\n      padding-right: 0;\n    }\n  }\n}\n\n// Image-Upload-Style on Profile\n\n.edit-image-wrapper {\n  position: relative;\n}\n\n.person-title {\n  max-width: 300px;\n  width: 100%;\n  margin-right: 15px;\n  margin-bottom: 15px;\n\n  @media screen and (max-width: 1200px) {\n    max-width: 240px;\n  }\n\n  .img-responsive {\n    max-width: 100%;\n    width: 100%;\n    display: inline-block;\n    background: #f2f2f2;\n  }\n\n  .m-b-sm {\n    padding: 5px;\n  }\n}\n\n.upload_button_holder {\n  position: absolute;\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  margin-top: -33px;\n\n  .upload_button {\n    position: relative;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 21px;\n    background: rgba(0, 0, 0, .4);\n    color: $color-light-type;\n    padding: 5px 0;\n    border-radius: 0;\n    width: 100%;\n    height: 32px;\n    text-decoration: none;\n    text-align: center;\n    cursor: pointer;\n    display: block;\n  }\n\n  .cloudinary_fileupload {\n    opacity: 0;\n    filter: alpha(opacity=0);\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    border: none;\n  }\n}\n\n// User-Profile-About-text\n\n.titlename.no-mg-top {\n  margin-top: 2px !important;\n}\n\n.right-buttons {\n  position: absolute;\n  right: 10px;\n  z-index: 9999;\n}\n\n.no-margin {\n  margin: 0;\n}\n\n.m-about p {\n  font-size: 14px;\n  line-height: 23px;\n}\n\n.profile-heading {\n  margin-left: -20px;\n  width: 105%;\n}\n\n.client-detail {\n  position: relative;\n  // min-height: 620px;\n  height: auto;\n\n  .profile-headers {\n    clear: both;\n    float: left;\n    width: 100%;\n    margin: 30px 0;\n    font-size: 18px;\n    font-family: \"Conv_museo-500-webfont\";\n\n    .profile-equation-wrapper {\n      font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n      span {\n        color: $color-light-type;\n        padding: 7px;\n      }\n\n      .eq-plus {\n        color: $color-neutral-dark;\n      }\n    }\n\n    .profile-equation-result {\n      background: $color-neutral-dark;\n      padding: 7px;\n      font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n      a {\n        color: $color-light-type;\n        text-decoration: none;\n      }\n    }\n  }\n\n  .client_description {\n    clear: both;\n    text-align: justify;\n    font-size: 16px;\n    margin-bottom: 30px;\n    -webkit-column-count: 2;\n    -ms-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 20;\n    -ms-column-gap: 20;\n    -moz-column-gap: 20;\n    column-gap: 20;\n\n    span.profile-desc {\n      font-weight: 700;\n    }\n  }\n}\n\n.right-label-text {\n\n  .eq-implementer {\n    background-color: $implement-color !important;\n  }\n\n  .eq-clarifier {\n    background-color: $clarify-color !important;\n  }\n\n  .eq-ideator {\n    background-color: $ideate-color !important;\n  }\n}\n\n\n::ng-deep .user-profile-icon-wrapper {\n  margin-top: -12px;\n  margin-left: 19px;\n\n  .unliked-profile {\n    display: inline-block;\n    margin-top: 20px;\n  }\n}\n\n.profile-btn-wrapper {\n  display: inline-block;\n  margin-top: 5px;\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  a {\n    font-size: 12px;\n  }\n}\n\n.collaborate-profile {\n  margin: 10px 0 15px 0;\n  float: left;\n  width: 100%;\n\n  span.left-label.profile-equation-result {\n    background: $color-neutral-dark;\n    padding: 7px;\n    font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 17px;\n    color: $color-light-type;\n\n    a {\n      color: $color-light-type !important;\n      text-decoration: none;\n    }\n  }\n\n  ::ng-deep .profile-equation-wrapper {\n    span {\n      padding: 7px;\n      color: $color-light-type;\n      font-size: 18px;\n      font-weight: normal;\n      display: inline-block;\n    }\n  }\n}\n\n.profile-headers h2 {\n  display: inline-block;\n}\n\n.right-buttons.collaboration-profile {\n  a {\n    padding: 4px 15px !important;\n    font-size: 13px;\n    margin: 0 !important;\n    height: 26px !important;\n    display: inline-block;\n    vertical-align: top;\n    line-height: 18px;\n\n    &.btn {\n      text-decoration: none !important;\n    }\n  }\n}\n\n\n.client-detail #cbpf6 {\n  margin-top: 10px;\n}\n\n.m-about .field_label,\n.m-about .m-image-block,\n.m-about .titlename span,\n.list-unstyled .not-strong {\n  font-family: 'Open Sans';\n}\n\n.th-pf-links {\n  margin-top: 6px;\n  margin-left: 10px;\n  display: inline-block;\n}\n\n.m-about .field_label.more-label {\n  width: 125px;\n}\n\n::ng-deep .inline-profile {\n  display: inline-block;\n}\n\n.member-orgs {\n\n  &__tbl-wrp {\n    \n    @media #{$tablet} {\n      overflow-x: scroll;\n    }\n\n    thead {\n      \n       th {\n        min-width: 135px;\n       }\n    }\n  }\n}\n\ntable {\n  &.user-profile {\n    tr {\n      &:nth-child(even) {\n        &:hover {\n          background-color: #f5f5f5;\n        }\n      }\n    }\n  } \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
